import React from "react";

/**
 * The Heading component will render an h1 tag with the "text" prop as the
 * text for the heading.
 *
 * @param { string } text -> The string that is used in the heading.
 */
export default function Legend({ text }) {
  return (
    <legend className="gc__heading">{text}</legend>
  )
}
